const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

function resolveImageUrl(url) {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${API_BASE_URL}${url}`;
  return `${API_BASE_URL}/${url}`;
}

function normalizeProduct(product) {
  if (!product) return product;
  return {
    ...product,
    isAvailable: Boolean(product.isAvailable),
    featured: Boolean(product.featured),
    popupEnabled: Boolean(product.popupEnabled),
    popupOrder: product.popupOrder == null ? null : Number(product.popupOrder),
    primaryImageUrl: resolveImageUrl(product.primaryImageUrl),
    images: Array.isArray(product.images) ? product.images.map(resolveImageUrl) : []
  };
}

function mapApiError(error, fallbackMessage) {
  if (error instanceof Error && error.name === 'TypeError') {
    return new Error('Server trenutno nije dostupan. Pokušajte ponovo za nekoliko minuta.');
  }
  if (error instanceof Error) {
    return error;
  }
  return new Error(fallbackMessage);
}

export const productService = {
  async getProducts(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.categoryId) params.set('categoryId', filters.categoryId);
      if (filters.search) params.set('search', filters.search);
      if (filters.available !== undefined) params.set('available', String(filters.available));
      if (filters.featured !== undefined) params.set('featured', String(filters.featured));

      const query = params.toString() ? `?${params.toString()}` : '';
      const response = await fetch(`${API_BASE_URL}/api/products${query}`);
      if (!response.ok) throw new Error('Greška pri učitavanju proizvoda');
      const payload = await response.json();
      return {
        ...payload,
        data: (payload.data || []).map(normalizeProduct)
      };
    } catch (error) {
      throw mapApiError(error, 'Greška pri učitavanju proizvoda');
    }
  },

  async getProductById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/products/${id}`);
      if (!response.ok) throw new Error('Proizvod nije pronadjen');
      const payload = await response.json();
      return normalizeProduct(payload);
    } catch (error) {
      throw mapApiError(error, 'Greška pri učitavanju proizvoda');
    }
  },

  async getCategories() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/categories`);
      if (!response.ok) throw new Error('Greška pri učitavanju kategorija');
      return await response.json();
    } catch (error) {
      throw mapApiError(error, 'Greška pri učitavanju kategorija');
    }
  },

  async getPopupProducts() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/products/popup`);
      if (!response.ok) throw new Error('Greška pri učitavanju popup proizvoda');
      const payload = await response.json();
      return {
        ...payload,
        data: (payload.data || []).map(normalizeProduct)
      };
    } catch (error) {
      throw mapApiError(error, 'Greška pri učitavanju popup proizvoda');
    }
  },

  async getHomePage() {
    try {
      const [featuredResponse, categories] = await Promise.all([
        fetch(`${API_BASE_URL}/api/products?featured=true`),
        this.getCategories()
      ]);

      if (!featuredResponse.ok) throw new Error('Greška pri učitavanju home podataka');
      const featuredData = await featuredResponse.json();

      return {
        featuredProducts: (featuredData.data || []).map(normalizeProduct),
        categories
      };
    } catch (error) {
      throw mapApiError(error, 'Greška pri učitavanju home podataka');
    }
  }
};
